export function Logo({ className = "" }) {
  return (
    <span className={`flex items-center gap-2 ${className}`}>
      <span className="flex h-9 w-9 items-center justify-center rounded-sm bg-[var(--gold)] font-display text-xl font-black text-black">IP</span>
      <span className="h-display text-2xl leading-none text-white">
        Iron<span className="text-[var(--gold)]">Pump</span>
      </span>
    </span>
  );
}
